import styled, { themeGet, device,css } from "@styled";


export const SectionWrap = styled.section`
    padding-block-start: 60px;
    padding-block-end:60px;
`;  



export const ContentBox = styled.div`
    padding-block-start:40px;
    padding-block-end:40px;
`

export const StyleHeading = styled.div`
    font-weight: 200;
    position: relative;
    line-height: 1.4;
    padding-inline-start: 34px;
    &:before {
        position: absolute;
        content: "";
        left: 0px;
        top: 50%;
        width: 4px;
        height: 94%;
        transform: translateY(-50%);
        background-color: ${themeGet("colors.secondary")};
    }
`

export const ContentBoxTitle = styled.h5`
    font-weight: 500;
    line-height: 1.25;
    font-size:24px;
    margin-block-end: 12px;
    color:#000;
`

export const ContentBoxText = styled.p`
    font-size: 16px;
    line-height: 1.67;
    padding-block-end:20px;
    color:#696969;
`;

export const ContentBoxImage = styled.figure`
    text-align:center;
    img {
        border-radius:${themeGet("radii.md")};
    }
`;





